const headerMapping = {
  databaseName: 'Training Provider',
  totalConfirmedClasses: 'Confirmed Classes',
  diskSizeMB: 'Database Size (MB)',
  'confirmedTraineesByMonth.1': 'January',
  'confirmedTraineesByMonth.2': 'February',
  'confirmedTraineesByMonth.3': 'March',
  'confirmedTraineesByMonth.4': 'April',
  'confirmedTraineesByMonth.5': 'May',
  'confirmedTraineesByMonth.6': 'June',
  'confirmedTraineesByMonth.7': 'July',
  'confirmedTraineesByMonth.8': 'August',
  'confirmedTraineesByMonth.9': 'September',
  'confirmedTraineesByMonth.10': 'October',
  'confirmedTraineesByMonth.11': 'November',
  'confirmedTraineesByMonth.12': 'December'
};



function flattenObject(obj, parent = '', res = {}) {
    for (let key in obj) {
      let propName = parent ? parent + '.' + key : key;
      if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        flattenObject(obj[key], propName, res);
      } else if (Array.isArray(obj[key])) {
        obj[key].forEach((item, index) => {
          flattenObject(item, `${propName}[${index}]`, res);
        });
      } else {
        res[propName] = obj[key] === '' ? null : obj[key];
      }
    }
    return res;
  }


  function capitalizeHeader(header) {
    return header.replace(/(?:^|\s|\.|-|\[|\])\S/g, x => x.toUpperCase());
  }



function convertToCSV(data) {
  const flattenedData = data.map(item => flattenObject(item));

  // Get original headers
  const originalHeaders = Object.keys(flattenedData[0]);

  // Map headers using headerMapping (fallback to original if no mapping exists)
  const mappedHeaders = originalHeaders.map(h => headerMapping[h] || capitalizeHeader(h));

  const array = [mappedHeaders].concat(flattenedData);

  // Add Grand Total row
  const grandTotal = {};
  Object.keys(flattenedData[0]).forEach(key => {
    if (key.startsWith('confirmedTraineesByMonth.')) {
      grandTotal[key] = flattenedData.reduce((sum, row) => sum + (Number(row[key]) || 0), 0);
    } else if (key === 'totalConfirmedClasses') {
      grandTotal[key] = flattenedData.reduce((sum, row) => sum + (Number(row[key]) || 0), 0);
    } else if (key === 'diskSizeMB') {
      grandTotal[key] = flattenedData.reduce((sum, row) => sum + (parseFloat(row[key]) || 0), 0).toFixed(2);
    } else if (key === 'databaseName') {
      grandTotal[key] = 'Grand Total';
    } else {
      grandTotal[key] = '';
    }
  });

  array.push(grandTotal);

  return array.map((row, index) => {
    if (index === 0) {
      return row.join(',');
    } else {
      return originalHeaders.map(header => `"${row[header] !== undefined ? row[header] : ''}"`).join(',');
    }
  }).join('\n');
}
  
  // Function to trigger the download of the CSV file
  function downloadCSV(csvContent, filename) {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  
  // Function to export data as CSV
  function exportDataSummaryToCSV(data, filename = 'export.csv') {
    const csvContent = convertToCSV(data);
    downloadCSV(csvContent, filename);
  }

export {
    exportDataSummaryToCSV
}